import React, { Component, Fragment } from "react";
import { Input, InputNumber, Spin, Switch } from "antd";
import { createPortal } from 'react-dom';
import { getPanelMaxWidth, getPanelWidth } from "../../services/helper/panelSizeHelper";
import Panel from "@/components/Panel/Panel";
import { getProjectGenericConfig, saveProjectGenericConfig } from '../../services/project';
import { numberCheck } from "../../services/helper/dataProcess";
import { userDefaultSettings } from "../../services/userDefaultSetting/userDefaultSettingCtrl";
import { SIERRA } from "../../constants/pageType";
import "./index.css";

const defaultGenericSettings = {
  macroModelingErrorTolerance: "0.001"
},
  sierraGenericSettings = {
    macroModelingErrorTolerance: "0.001",
    parallelExtractionConfig: {
      enableParallelExtraction: true,
      maxParallelExtractionNumber: null
    }
  }

class GenericSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      genericSettings: props.product === SIERRA ? JSON.parse(JSON.stringify(sierraGenericSettings)) : { ...defaultGenericSettings },
      genericInputSettings: { ...defaultGenericSettings },
      errorMsg: null,
      maxWidth: 800,
      loading: true
    }
    this.dialogRoot = document.getElementById('root');
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  resize = () => {
    const offset = this.dialogRoot.getBoundingClientRect();
    this.setState({
      maxWidth: getPanelMaxWidth(offset, 600)
    })
  }

  componentDidMount = async () => {
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getData()
  };

  componentDidUpdate = (prevProps) => {
    const { projectId } = this.props;
    if (projectId !== prevProps.projectId) {
      this.props.closePanel()
    }
  }

  getData = async () => {
    const { projectId, product } = this.props;
    if (!projectId) {
      this.setState({
        loading: false
      })
      return;
    }
    try {
      const settings = await getProjectGenericConfig(projectId);
      const genericExist = settings && settings.generic && Object.keys(settings.generic).length;
      let generic = genericExist ? settings.generic : {};
      if (!genericExist) {
        //get generic setting by user default settings
        const res = await userDefaultSettings.getSettings();
        const userSettingGeneric = res && res.genericSettings ? res.genericSettings : {};
        generic = {
          macroModelingErrorTolerance: userSettingGeneric.macroModelingErrorTolerance || defaultGenericSettings.macroModelingErrorTolerance
        }
      }
      // Sierra parallelExtractionConfig
      if (product === SIERRA && !generic.parallelExtractionConfig) {
        const res = await userDefaultSettings.getSettings();
        const userSierraSetting = res && res.sierraSettings ? res.sierraSettings : {};
        generic.parallelExtractionConfig = userSierraSetting.parallelExtractionConfig ? { ...userSierraSetting.parallelExtractionConfig }
          : {
            ...sierraGenericSettings.parallelExtractionConfig
          }
      }
      this.setState({
        genericSettings: { ...(generic || {}) },
        genericInputSettings: { ...(generic || {}) },
        loading: false
      })
    } catch (error) {
      this.setState({
        loading: false
      })
      console.error(error)
    }
  }

  closeModal = () => {
    const { genericSettings } = this.state;
    const { projectId } = this.props;
    try {
      saveProjectGenericConfig({ projectId, updateType: "generic", settings: { generic: genericSettings } });
    } catch (error) {
      console.error(error)
    }
    this.props.closePanel();
  }

  changeGenericSettingsInput = (e, type) => {
    const { genericInputSettings, errorMsg } = this.state;
    let _genericInputSettings = { ...genericInputSettings || {} };
    this.setState({
      genericInputSettings: { ..._genericInputSettings, [type]: e.target.value },
      errorMsg: errorMsg && errorMsg.type === type ? null : errorMsg
    })
  }

  saveGenericSettingsInput = (e, type) => {
    const { genericInputSettings, genericSettings, errorMsg: prevErrorMsg } = this.state;
    let value = e.target.value;
    let _genericInputSettings = { ...genericInputSettings || {} },
      _genericSettings = { ...genericSettings || {} };
    let error = null;
    error = numberCheck(value, true);
    //range [1e-4,0.3]
    if (!error && (parseFloat(value) < 1e-4 || parseFloat(value) > 0.3)) {
      error = "Value should be between 1e-4 ~ 0.3."
    }
    if (!error) {
      _genericSettings = { ..._genericSettings, [type]: value };
    }
    this.setState({
      genericInputSettings: { ..._genericInputSettings, [type]: value },
      genericSettings: _genericSettings,
      errorMsg: error ? { type, error } : prevErrorMsg && prevErrorMsg.type === type ? null : prevErrorMsg
    })
  }

  valueChangeHandler = (value, option, parentOption) => {
    const { genericSettings } = this.state;
    this.setState({
      genericSettings: {
        ...genericSettings,
        [parentOption]: {
          ...(genericSettings[parentOption] || {}),
          [option]: value
        }
      }
    })
  }

  render() {
    const { maxWidth, genericInputSettings, errorMsg, loading, genericSettings } = this.state;
    const { product = "" } = this.props;
    const { macroModelingErrorTolerance } = genericInputSettings || {};
    const { parallelExtractionConfig = {} } = genericSettings || {};

    const content = (
      <Panel
        className={`project-generic-settings-content-panel ${product.toLowerCase()}-panel`}
        title={<span>Generic Settings</span>}
        onCancel={this.closeModal}
        zIndex={2000}
        width={getPanelWidth(maxWidth, { defaultWidth: 600 })}
        position='panel-center'
        draggable
        maxWidth={maxWidth}
        minHeight={200}
        minWidth={200}
      >
        <div className='project-generic-settings-content'>
          <Spin spinning={loading} tip={loading ? `Loading...` : ''}>
            <div className="generic-settings-item">
              <span className='generic-settings-item-title'>Macro-Modeling error tolerance</span>
              <Input
                addonAfter="%"
                className="aurora-input"
                value={macroModelingErrorTolerance}
                onChange={(e) => this.changeGenericSettingsInput(e, "macroModelingErrorTolerance")}
                onBlur={(e) => this.saveGenericSettingsInput(e, "macroModelingErrorTolerance")}
              />
            </div>
            {product === SIERRA ?
              <Fragment>
                <div className="generic-settings-item generic-settings-parallel-extraction-item">
                  <span className='generic-settings-item-title'>Enable Extraction Parallelization</span>
                  <Switch
                    size="small"
                    className="aurora-switch-small"
                    checked={parallelExtractionConfig.enableParallelExtraction}
                    onChange={(checked) => this.valueChangeHandler(checked, 'enableParallelExtraction', "parallelExtractionConfig")}
                  />
                </div>
                {parallelExtractionConfig.enableParallelExtraction ? <div className="generic-settings-item generic-settings-max-extraction-item">
                  <span className='generic-settings-item-title'>Max number of Parallel PCB Model Extraction</span>
                  <InputNumber
                    min={1}
                    className="aurora-input"
                    placeholder="Use the max number of extraction workers"
                    defaultValue={null}
                    value={parallelExtractionConfig.maxParallelExtractionNumber}
                    onChange={(value) => this.valueChangeHandler(value, 'maxParallelExtractionNumber', "parallelExtractionConfig")}
                  />
                </div> : null}
              </Fragment> : null}
            {errorMsg && errorMsg.error ? <div className="aurora-model-name-error-msg">{errorMsg.error}</div> : null}
          </Spin>
        </div>
      </Panel>
    )
    return createPortal(content, this.dialogRoot);
  }
}

export default GenericSettings;
